import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useCompanyConfigQuery } from "../../../SWR/Company/useCompanyConfigQuery";
import { ConditionalLink } from "../ConditionalLink";
import { BrandLogo } from "./BrandLogo";
import { useEnvironment } from "../EnvironmentProvider/EnvironmentProvider";
/**
 * Brand Logo component that links to the company's website.
 * @param logoStyles
 * @param typographyVariant - defaults to an h3 element
 * @returns
 */
export const BrandLogoLink = ({ logoStyles, typographyVariant = "h3", typographyColor = "primary", }) => {
    var _a, _b, _c, _d;
    const { url, displayName } = useCompanyConfigQuery();
    const { imageBaseURL } = useEnvironment();
    const theme = useTheme();
    // Brand logo values are sourced from theme.custom.brand, populated via BrandThemeMap
    // and written into Brand.Theme by BrandService.SetTheme(). Use optional chaining
    // defensively — custom.brand will be absent for any tenant whose Brand.Theme blob
    // predates the MT-7241 BrandThemeMap migration until Force Theme Update is run.
    const logoUrl = (_b = (_a = theme.custom) === null || _a === void 0 ? void 0 : _a.brand) === null || _b === void 0 ? void 0 : _b.logoUrl;
    const logoIsWhite = (_d = (_c = theme.custom) === null || _c === void 0 ? void 0 : _c.brand) === null || _d === void 0 ? void 0 : _d.logoIsWhite;
    return (_jsx(ConditionalLink, Object.assign({ url: url }, { children: logoUrl ? (_jsx(BrandLogo, Object.assign({}, { logoUrl, logoIsWhite, displayName, imageBaseURL, logoStyles, typographyVariant, typographyColor }))) : (_jsx(Typography, Object.assign({ variant: typographyVariant, color: typographyColor }, { children: displayName }))) })));
};
